<div class="dtm-form-wrapper">
  <form [formGroup]="addEditLandscapeForm" class="fields-wrapper">
    <div class="surface-model-fields">
      <h1 class="title" *ngIf="isCreateMode">{{ "components.dtmTab.customElevations.add" | translate }}</h1>
      <h1 class="title" *ngIf="isUpdateMode">{{ "components.dtmTab.customElevations.edit" | translate }}</h1>

      <mat-form-field>
        <input
          formControlName="Company"
          type="text"
          [placeholder]="'components.dtmTab.customElevations.company' | translate"
          required
          matInput
          [matAutocomplete]="auto"
          autocomplete="off"
          [matAutocompleteDisabled]="isCompanyAdmin"
        />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCompanyChange($event)" [displayWith]="displayCompanyProperty">
          <mat-option *ngFor="let company of filteredCompaniesData$ | async" [value]="company">
            {{ company.Name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="name-wrapper">
        <input matInput placeholder="{{ 'components.dtmTab.customElevations.name' | translate }}" required formControlName="Name" />
        <span matSuffix>{{ addEditLandscapeForm.get("Slug").value }}</span>
        <mat-error *ngIf="getControlError('Name', 'required')">
          {{ "validation.required" | translate: { name: "Name" } }}
        </mat-error>
        <mat-error *ngIf="getControlError('Name', 'notUnique')">
          {{ "components.dtmTab.customElevations.customElevationUniqueName" | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="isSuperAdmin">
        <input
          formControlName="Slug"
          [disabled]="isUpdateMode"
          type="text"
          required
          [placeholder]="'components.dtmTab.customElevations.slug' | translate"
          matInput
          [maxLength]="identifierMaxLength"
        />
        <mat-error *ngIf="getControlError('Slug', 'pattern')">
          {{ "validation.is_not_valid" | translate: { name: "Identifier" } }}
        </mat-error>
        <mat-error *ngIf="getControlError('Slug', 'required')">
          {{ "validation.required" | translate: { name: "Identifier" } }}
        </mat-error>
      </mat-form-field>

      <div class="visibility">
        <mat-form-field>
          <mat-icon class="help-tooltip" *ngIf="isShowScopeTooltip" [matTooltip]="getScopeTooltipText()"> help_outline </mat-icon>
          <mat-select formControlName="Scope" required placeholder="{{ 'permissions.visibility' | translate }}">
            <mat-option [value]="scopes.CompanyScope">
              {{ "permissions.scope.company" | translate }}
            </mat-option>
            <mat-option [value]="scopes.TeamPublicScope">
              {{ "permissions.scope.teamPublic" | translate }}
            </mat-option>
            <mat-option [value]="scopes.TeamPrivateScope" [disabled]="isPrivateVisibilityDisabled">
              <span [matTooltip]="privateVisibilityDisabledTooltipText | translate">
                {{ "permissions.scope.teamPrivate" | translate }}
              </span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getControlError('Scope', 'required')">{{ "validation.required" | translate: { name: "Scope" } }} </mat-error>
        </mat-form-field>
      </div>

      <div class="warning-about-set-public" *ngIf="isShowWarningAboutSetPublic">
        <mat-icon class="icon">error_outline</mat-icon>
        <p class="text">{{ "permissions.warningAboutSetPublic" | translate }}</p>
      </div>

      <div *ngIf="isShowTeamField">
        <mat-form-field>
          <input
            formControlName="OwnerTeamId"
            type="text"
            [placeholder]="'components.dtmTab.customElevations.team' | translate"
            matInput
            required
            [matAutocomplete]="auto"
            autocomplete="off"
            [matAutocompleteDisabled]="isTeamAdmin"
          />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onTeamChange($event)" [displayWith]="displayTeamProperty">
            <mat-option *ngFor="let company of filteredTeamsData$ | async" [value]="company">
              {{ company.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="model-details-fields">
      <h2 class="title">{{ 'components.dtmTab.customElevations.ModelDetails' | translate }}</h2>

      <div class="details-fields">
        <mat-form-field>
          <mat-select
            formControlName="Type"
            required
            disabled
            placeholder="{{ 'components.dtmTab.customElevations.elevationType' | translate }}"
          >
            <mat-option *ngFor="let landscape of landscapes" [value]="landscape.value">
              {{ landscape.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getControlError('Type', 'required')">
            {{ "validation.required" | translate: { name: "Elevation Type" } }}
          </mat-error>
        </mat-form-field>

        <mee-arcgis-custom-elevation-form
          [isUpdateMode]="isUpdateMode"
          [selectedCustomElevation]="dialogData.selectedCustomElevation"
          [elevationServerUrls]="elevationServerUrls"
          (arcGisDataChanged)="arcGisDataChanged($event)"
        ></mee-arcgis-custom-elevation-form>
      </div>
    </div>
  </form>

  <div class="action-buttons">
    <button class="cancel-button" [mat-dialog-close]="null" mat-button>{{ "system.cancel" | translate | uppercase }}</button>
    <button (click)="onAddEditLandscape()" mat-raised-button class="add-button" [disabled]="getIsValidFormFunction()">
      <span *ngIf="isCreateMode">{{ "components.dtmTab.customElevations.addButton" | translate | uppercase }}</span>
      <span *ngIf="isUpdateMode">{{ "components.dtmTab.customElevations.applyButton" | translate | uppercase }}</span>
    </button>
  </div>
</div>
